import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';
import { CdnIcon } from '@shared/ui';
const PaymentResult = ({ result, onClick, onBackToOrder, isOpen = true, onClose, successAdditionalBanner }) => {
    const { Payment: css } = useTheme('Entities');
    const { t } = useTranslation('PaymentResult');
    const centerIcon = result === 'fail' ? 'Info/Cancel' : 'Info/Item Icluded';
    const hasBanner = result === 'success' && !!successAdditionalBanner;
    return (React.createElement(ModalX, { classes: {
            paper: cn(css.wrapper, { [css.wrapper_withBanner]: hasBanner }),
            top_wrapper: css.topWrapper
        }, isOpen: isOpen, onClose: onClose },
        React.createElement("div", { className: cn(css.icon_container, {
                [css.icon_fail]: result === 'fail',
                [css.icon_success]: result === 'success'
            }) },
            React.createElement(CdnIcon, { icon: centerIcon, className: cn(css.center_icon) })),
        React.createElement("div", { className: cn(css.header, {
                [css.failed]: result === 'fail',
                [css.success]: result === 'success'
            }) },
            React.createElement("div", { className: css.icons },
                React.createElement(CdnIcon, { icon: 'Action/Payment' }),
                React.createElement("div", { className: css.paymentDots, "aria-hidden": "true" }),
                React.createElement(CdnIcon, { icon: 'Flight/Direction' }))),
        React.createElement("div", { className: css.content },
            React.createElement("div", { className: css.title }, result === 'success' ? t('Payment successfully complete') : t('Payment has failed')),
            result === 'success' && successAdditionalBanner,
            React.createElement("div", { className: css.buttons }, result === 'success' ? (React.createElement(BaseButton, { onClick: () => {
                    onClick(true);
                }, className: cn(css.redirectButton, css.redirectButton_success) }, t('View booking'))) : (React.createElement(React.Fragment, null,
                React.createElement(BaseButton, { onClick: onBackToOrder, className: css.redirectButton }, t('View booking')),
                React.createElement(BaseButton, { onClick: () => {
                        onClick(true);
                    }, className: css.redirectButton }, t('Try again'))))))));
};
export default PaymentResult;
